import CapitalizeString from './capitalizeString'

export const getCurrentEpochMinutesPrecise = () => {
  return Math.floor(new Date().getTime() / 1000)
}

export const transformDateToEpoch = (date) => {
  const newDate = new Date(date)
  const dateWithoutMilliseconds = Math.floor(newDate.getTime() / 1000)
  return dateWithoutMilliseconds
}

export const getYesterday = () => {
  const date = new Date()
  date.setDate(date.getDate() - 1)
  const newDate = new Date(date).setHours(23, 59, 0, 0)
  return transformDateToEpoch(newDate)
}

export const getMidnight = (date) => {
  const newDate = new Date(date)
  const midnightDate = newDate.setHours(0, 0, 0, 0)
  return transformDateToEpoch(midnightDate)
}

export const formatDateWithOptions = (date, options) => {
  const formatedDate = new Date(date)
  return formatedDate.toLocaleString('pt-BR', options)
}

export const transformEpochToDateTime = (epoch) => {
  const normalized = new Date(0)
  const dateTime = new Date(normalized.setUTCSeconds(epoch))
  return dateTime.toDateString()
}

export const transformEpochToDate = (epoch) => {
  const normalized = new Date(0)
  const dateTime = new Date(normalized.setUTCSeconds(epoch))
  return dateTime
}

export const transformStringToDate = (date) => {
  const formatedDate =
    date &&
    date.map(
      (d) =>
        `${new Date(d.split('-')).toLocaleDateString('pt-BR', { day: 'numeric' })} ${CapitalizeString(
          new Date(d.split('-')).toLocaleDateString('pt-BR', { month: 'short' }),
        )}`,
    )
  return formatedDate
}

export const transformStringToHours = (date) => {
  const formatedDate =
    date && date.map((d) => `${new Date(d.split('-')).toLocaleTimeString('pt-BR', { hour: '2-digit' })}h`)
  return formatedDate
}

export const formatedDateByGraph = (date) => {
  return `${new Date(date.split('-')).toLocaleTimeString('pt-BR', { hour: '2-digit' })}h`
}
